// extracted by mini-css-extract-plugin
export default {"buyerCell":"JACYuaP2RiWI17AyvPf1__buyerCell___","buyerWrap":"vARkeEJGrASbMFcH3o_l__buyerWrap___"};